import { IAutomationObject } from '../../types'

export interface IAnalogSetpoint extends IAutomationObject {
    value: number;
    dimension: string;
    limitMin: number | undefined;
    limitMax: number | undefined;
    onValueChanged: any;
}


export const schema = 'AutomationApps.Functions.SetPoints.AnalogSetpoint';
export const schemaTemperature = 'AutomationApps.Functions.SetPoints.TemperatureSetpoint';
export const schemaHumidity = 'AutomationApps.Functions.SetPoints.HumiditySetpoint';
export const schemaSupplyPressure = 'AutomationApps.Functions.SetPoints.SupplyPressureSetpoint';
export const schemaExhaustPressure = 'AutomationApps.Functions.SetPoints.ExhaustPressureSetpoint';


